<template>
  <div class="container">
    <div class="wifi"><component :is="wifiIcon" class="icon" /></div>
    <div class="battery">
      <component :is="batteryIcon" class="icon" /> <label>{{ deviceStore.batteryPercent }}%</label>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  // 와이파이 SVG들
  import IconWifi1 from '@/assets/images/wifi-1.svg?component';
  import IconWifi2 from '@/assets/images/wifi-2.svg?component';
  import IconWifi3 from '@/assets/images/wifi-3.svg?component';
  import IconWifi4 from '@/assets/images/wifi-4.svg?component';
  import IconWifiNo from '@/assets/images/wifi-no.svg?component';

  // 배터리 SVG들
  import IconBattery1 from '@/assets/images/battery-1.svg?component';
  import IconBattery2 from '@/assets/images/battery-2.svg?component';
  import IconBattery3 from '@/assets/images/battery-3.svg?component';
  import IconBattery4 from '@/assets/images/battery-4.svg?component';
  import IconBatteryCharging from '@/assets/images/battery-charging.svg?component';
  import { useDeviceStore } from '@/stores/device';

  const deviceStore = useDeviceStore();

  // 1. 아이콘 매핑 테이블
  const iconMap = {
    wifi: {
      0: IconWifiNo,
      1: IconWifi1,
      2: IconWifi2,
      3: IconWifi3,
      4: IconWifi4,
    },
    battery: {
      0: IconBatteryCharging,
      1: IconBattery1,
      2: IconBattery2,
      3: IconBattery3,
      4: IconBattery4,
    },
  };

  // 배터리 아이콘
  const batteryIcon = computed(() => {
    return iconMap.battery[deviceStore.batteryState] || IconBattery1;
  });

  // 와이파이  아이콘
  const wifiIcon = computed(() => {
    return iconMap.wifi[deviceStore.wifiState] || IconWifiNo;
  });
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    gap: 1.1719vw;

    .battery {
      display: flex;
      align-items: center;
    }

    .battery {
      display: flex;
      align-items: center;
      gap: 0.3906vw;
    }
    .icon {
      color: var(--text-contrast-color);
    }
  }
</style>
